import type { FieldDefinition } from "@/types/template";

/**
 * Starter graphic every new SVG session opens with — the vector-mode
 * analogue of STARTER_TSX. A single self-contained <svg> (no <script>), so
 * it satisfies the backend's SVG checkpoint validation and previews as-is.
 *
 * Its gradient stops carry `{{accentColor}}` / `{{secondaryColor}}` tokens so
 * the Fields tab drives the colors out of the box (see STARTER_SVG_FIELDS).
 * The preview substitutes tokens before rendering; the raw source keeps them.
 */
export const STARTER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
  <defs>
    <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="{{accentColor}}"/>
      <stop offset="1" stop-color="{{secondaryColor}}"/>
    </linearGradient>
  </defs>
  <g id="mark">
    <circle cx="256" cy="256" r="200" fill="url(#bg)"/>
    <circle cx="256" cy="256" r="150" fill="none" stroke="#ffffff" stroke-width="12" opacity="0.9"/>
    <path id="bolt" d="M276 156 L216 276 L256 276 L236 356 L316 226 L268 226 Z" fill="#ffffff"/>
  </g>
</svg>
`;

/** Fields wired to the starter's `{{...}}` tokens. Plain SVG field types
 *  (color) — the backend accepts these for SVG templates. */
export const STARTER_SVG_FIELDS: FieldDefinition[] = [
  {
    key: "accentColor",
    label: "Accent color",
    type: "color",
    default: "#2563eb",
    required: false,
  },
  {
    key: "secondaryColor",
    label: "Secondary color",
    type: "color",
    default: "#7c3aed",
    required: false,
  },
];
